import { useId } from 'react';

/**
 * The Mobilidade Lousada mark: an M drawn as one folded ribbon, green where it starts and
 * turning orange on the last stroke, the way a journey ends at an orange destination pin.
 */
export function BrandMark({ size = 40 }: { size?: number }): React.JSX.Element {
  const id = useId();
  const fade = `${id}-fade`;
  return (
    <svg
      className="brand-mark"
      width={size}
      height={size * 0.625}
      viewBox="0 0 64 40"
      aria-hidden="true"
      focusable="false"
    >
      <defs>
        <linearGradient id={fade} x1="0" y1="0" x2="0" y2="1">
          <stop offset="0" stopColor="#056a33" />
          <stop offset="0.38" stopColor="#ff6b00" />
          <stop offset="1" stopColor="#ff6b00" />
        </linearGradient>
      </defs>
      <g fill="none" strokeWidth="10" strokeLinejoin="round">
        <path d="M7 34 18 14 26 31 38 8 55 34" stroke="#07893f" />
        <path d="M18 14 26 31" stroke="#056a33" />
        <path d="M7 34 18 14" stroke="#10a95a" />
        <path d="M38 8 55 34" stroke={`url(#${fade})`} />
      </g>
    </svg>
  );
}
